<template>
  <Modal v-model="modal" :title="$t('title.w21')" :mask-closable="false" @on-visible-change="visibleChange">
    <div class="rela">
      <Spin size="large" fix v-if="uploading"></Spin>
      <Form label-position="top" :model="form" ref="form" :rules="formRule">
        <!-- 验证前 -->
        <template v-if="state==null">
          <FormItem :label="$t('label.w30')" prop="countryId" v-show="state==null" :style="{marginBottom:'15px'}">
            <Select v-model="form.countryId">
              <Option v-for="item in countryList" :value="item.Id" :key="item.Id">{{ item.Name }}</Option>
            </Select>
          </FormItem>
          <Alert type="warning" show-icon :style="{marginBottom:'20px'}">
            <div
              slot="desc"
            >{{$t('msg.m16')}} <br/>{{$t('msg.m123')}}<br/>{{$t('msg.m17')}}</div>
          </Alert>
        </template>

        <!-- 身份证 -->
        <template v-if="form.countryId===0">
          <div :style="{width:'240px',margin:'0 auto'}">
            <IDCard v-if="modal" ref="IDCard" @valid="v=>disabled=!v" @done="done" @reset="state=null"/>
          </div>

          <!-- 验证通过 -->
          <template v-if="state==true">
            <FormItem :label="$t('label.w31')">
              <div class="idmsg">
                {{form.name}}
                <span>|</span>
                {{form.idNo}}
              </div>
            </FormItem>
            <FormItem :label="$t('label.w32')" prop="address">
              <Input v-model="form.address"/>
            </FormItem>
          </template>

          <!-- 验证失败 -->
          <template v-if="state==false">
            <Alert type="error" show-icon>
              {{idcardErrmsg}}
              <span slot="desc">{{$t('msg.m19')}}</span>
            </Alert>
          </template>
        </template>

        <!-- 护照 -->
        <template v-else>
          <div :style="{width:'240px',margin:'0 auto'}">
            <Passport
              v-if="modal"
              ref="Passport"
              :countryId="form.countryId"
              @valid="v=>disabled=!v"
              @done="passportdone"
              @reset="state=null"
            />
          </div>
          <template v-if="state==false">
            <Alert type="error" show-icon>
              {{$t('msg.m20')}}
              <span slot="desc">{{passportmsg}}</span>
            </Alert>
          </template>
          <template v-if="state==true">
            <Alert type="success" show-icon>
              {{$t('msg.m21')}}
              <span slot="desc">{{passportmsg}}</span>
            </Alert>
          </template>
        </template>
      </Form>
    </div>

    <template slot="footer">
      <div v-if="form.countryId===0">
        <Button
          type="primary"
          v-if="state==null"
          @click="next"
          :loading="uploading"
          :disabled="disabled"
        >{{uploading?$t('btn.b50'):$t('btn.b4')}}</Button>
        <Button type="primary" v-if="state==true" @click="submit" :disabled="form.address==''">{{$t('btn.b46')}}</Button>
        <Button type="primary" v-if="state==false" @click="reset('IDCard')">{{$t('btn.b48')}}</Button>
      </div>
      <div v-else>
        <Button type="primary"
          @click="passportsubmit"
          v-if="state==null"
          :loading="uploading"
          :disabled="disabled"
        >{{$t('btn.b49')}}</Button>
        <Button type="primary" v-if="state==true" @click="modal=false">{{$t('btn.b5')}}</Button>
        <Button type="primary" v-if="state==false" @click="reset('Passport')">{{$t('btn.b48')}}</Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { getOnce } from "@/libs/axios"
import IDCard from "@/components/IDCardValid"
import Passport from "@/components/PassportValid"
import {mapGetters} from 'vuex'
export default {
  components: { IDCard ,Passport},
  data() {
    return {
      countryList: [],
      disabled: true,
      form: {
        countryId: 0,
        address: "",
      },
      formRule: {
        address: [
          { required: true, message: this.$t('msg.m25'), trigger: "submit" }
        ]
      },
      modal: false,
      uploading: false,
      state: null,
      passportmsg:'',
      idcardErrmsg:''
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'userSafe'])
  },
  mounted() {
    this.getCountryList();
  },
  methods: {
    getCountryList() {
      getOnce("/Member/RZJProfile/CountryList").then(res => {
        if (res.err) return res.thorw();
        this.countryList = res.CountryList;
      });
    },
    next() {
      this.uploading = true;
      this.$refs.IDCard.submit();
    },
    done(res) {
      this.uploading = false;
      if (res.err) {
        this.state = false;
        this.$refs.IDCard.state = false;
        this.idcardErrmsg=res.msg
      } else {
        this.idcardErrmsg=''
        this.form.fileName = res.fileName;
        this.form.name = res.authenInfo.name;
        this.form.gender = res.authenInfo.gender == "男" ? 1 : 2;
        this.form.idNo = res.authenInfo.idNo;
        this.form.address = res.authenInfo.address;
        this.form.birthDay = res.authenInfo.birthDay;
        // this.form.province = res.authenInfo.province;
        // this.form.city = res.authenInfo.city;
        // this.form.prefecture = res.authenInfo.prefecture;
        this.state = true;
        this.$refs.IDCard.state = true;
      }
    },
    reset(t) {
      this.state = null;
      if(this.$refs[t]) this.$refs[t].reset();
    },
    submit() {
      this.$axios.post("/Member/RZJProfile/EsignIdCardAuthen", this.form).then(res => {
        if (res.err) return res.throw();
        this.$store.dispatch("user/getUser",'all');
        this.$Message.success(this.$t('msg.m30'));
        this.modal = false;
      });
    },
    passportsubmit(){
      this.uploading = true;
      this.$refs.Passport.submit();
    },
    passportdone(res){
      this.uploading = false
      this.passportmsg=res.msg
      if (res.err) {
        this.state = false;
        this.$refs.Passport.state = false;
      }else{
        this.state = true;
        this.$refs.Passport.state = true;
        this.$store.dispatch("user/getUser",'all');
      }
    },
    visibleChange(v){
      if(v) return;
      this.reset('IDCard')
      this.reset('Passport')
    }
  }
};
</script>

<style lang="less" scoped>
.rela {
  position: relative;
}
.idmsg {
  font-size: 18px;
  padding: 0 10px;
  > span {
    margin: 0 15px;
  }
}

</style>
